import * as React from 'react';

import { SkillPathwayActivelyEnrollingProvider } from 'bundles/enterprise-learning-path-description-page/contexts/SkillPathwayActivelyEnrollingContext';
import EnterpriseLearningPathCurriculumModuleCountProvider from 'bundles/enterprise-learning-path-description-page/providers/EnterpriseLearningPathCurriculumModuleCountProvider';
import EnterpriseLearningPathCurriculumProvider from 'bundles/enterprise-learning-path-description-page/providers/EnterpriseLearningPathCurriculumProvider';
import EnterpriseLearningPathSkillsDataProvider from 'bundles/enterprise-learning-path-description-page/providers/EnterpriseLearningPathSkillsDataProvider';
import SkillPathwayPartnersDataProvider from 'bundles/enterprise-learning-path-description-page/providers/SkillPathwayPartnersDataProvider';
import UserDataProvider from 'bundles/unified-description-page-common/providers/user/UserDataProvider';

const EnterpriseSkillPathwayPageDataProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <EnterpriseLearningPathSkillsDataProvider>
      <EnterpriseLearningPathCurriculumProvider>
        <SkillPathwayActivelyEnrollingProvider>
          <EnterpriseLearningPathCurriculumModuleCountProvider>
            <SkillPathwayPartnersDataProvider>
              <UserDataProvider>{children}</UserDataProvider>
            </SkillPathwayPartnersDataProvider>
          </EnterpriseLearningPathCurriculumModuleCountProvider>
        </SkillPathwayActivelyEnrollingProvider>
      </EnterpriseLearningPathCurriculumProvider>
    </EnterpriseLearningPathSkillsDataProvider>
  );
};

export default EnterpriseSkillPathwayPageDataProvider;
